import { useConeSearchOverlay } from '../context/ConeSearchOverlayContext';
import OverlayTemplate from './common/OverlayTemplate';
import ConeSearchContent from './cone-search/ConeSearchContent';

const ConeSearchOverlay = () => {
  const { isOpen, isMinimized, toggleMinimized } = useConeSearchOverlay();

  const icon = (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  );

  return (
    <OverlayTemplate
      isOpen={isOpen}
      isMinimized={isMinimized}
      onClose={toggleMinimized}
      onToggleMinimize={toggleMinimized}
      title="Cone Search"
      icon={icon}
      minimizedTabText="Cone"
      width="700px"
      zIndex={54}
      minimizedTabPosition="20%"
    >
      <div className="p-6">
        <ConeSearchContent showTitle={false} />
      </div>
    </OverlayTemplate>
  );
};

export default ConeSearchOverlay;
